// import App from "@/App.vue";
// import { useAuthStore } from "@/stores/auth";
// import { createPinia } from "pinia";
// import { createApp } from "vue";
// import { onMounted } from "vue";
// import { useAuthStore } from "@/stores/auth";
// import { onMounted } from "vue";
import { createWebHistory, createRouter } from "vue-router";

const routes = [
  {
    path: "/",
    name: "index",
    component: () => import('@/pages/index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/users",
    name: "users",
    component: () => import('@/pages/users/Users.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/user/add",
    name: "user.add",
    component: () => import('@/pages/users/Add.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/user/update/:id",
    name: "user.update",
    component: () => import('@/pages/users/Add.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/user/show/:id",
    name: "user.show",
    component: () => import('@/pages/users/Show.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/profile",
    name: "profile",
    component: () => import('@/pages/user-profile/profile.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  // {
  //   path: "/explore-property",
  //   name: "explore-property",
  //   component: () => import('@/pages/explore-property.vue'),
  // },
  // {
  //   path: "/favorite-property",
  //   name: "favorite-property",
  //   component: () => import('@/pages/favorite-property.vue'),
  // },
  // {
  //   path: "/add-property",
  //   name: "add-property",
  //   component: () => import('@/pages/add-property.vue'),
  // },
  // {
  //   path: "/property-detail",
  //   name: "property-details",
  //   component: () => import('@/pages/property-detail.vue'),
  // },
  // {
  //   path: "/property-detail/:id",
  //   name: "property-detail",
  //   component: () => import('@/pages/property-detail.vue'),
  // },
  // {
  //   path: "/chat",
  //   name: "chat",
  //   component: () => import('@/pages/chat.vue'),
  // },

  // {
  //   path: "/profile-setting",
  //   name: "profile-setting",
  //   component: () => import('@/pages/user-profile/profile-setting.vue'),
  // },
  // {
  //   path: "/blog",
  //   name: "blog",
  //   component: () => import('@/pages/blog/blog.vue'),
  // },
  // {
  //   path: "/blog-detail",
  //   name: "blog-details",
  //   component: () => import('@/pages/blog/blog-detail.vue'),
  // },
  // {
  //   path: "/blog-detail/:id",
  //   name: "blog-detail",
  //   component: () => import('@/pages/blog/blog-detail.vue'),
  // },
  // {
  //   path: "/starter",
  //   name: "starter",
  //   component: () => import('@/pages/pages/starter.vue'),
  // },
  // {
  //   path: "/faqs",
  //   name: "faqs",
  //   component: () => import('@/pages/pages/faqs.vue'),
  // },
  // {
  //   path: "/pricing",
  //   name: "pricing",
  //   component: () => import('@/pages/pages/pricing.vue'),
  // },
  // {
  //   path: "/review",
  //   name: "review",
  //   component: () => import('@/pages/pages/review.vue'),
  // },
  // {
  //   path: "/privacy",
  //   name: "privacy",
  //   component: () => import('@/pages/pages/privacy.vue'),
  // },
  // {
  //   path: "/terms",
  //   name: "terms",
  //   component: () => import('@/pages/pages/terms.vue'),
  // },
  {
    path: "/login",
    name: "login",
    component: () => import('@/pages/auth-pages/login.vue'),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/signup",
    name: "signup",
    component: () => import('@/pages/auth-pages/signup.vue'),
  },
  {
    path: "/signup-success",
    name: "signup-success",
    component: () => import('@/pages/auth-pages/signup-success.vue'),
  },
  {
    path: "/password-reset/:token",
    name: "password-reset",
    component: () => import('@/pages/auth-pages/reset-password.vue'),
  },
  {
    path: "/forgot-password",
    name: "forgot-password",
    component: () => import('@/pages/auth-pages/forgot-password.vue'),
  },
  // {
  //   path: "/lock-screen",
  //   name: "lock-screen",
  //   component: () => import('@/pages/auth-pages/lock-screen.vue'),
  // },
  // {
  //   path: "/comingsoon",
  //   name: "comingsoon",
  //   component: () => import('@/pages/miscellaneous/comingsoon.vue'),
  // },
  // {
  //   path: "/maintenance",
  //   name: "maintenance",
  //   component: () => import('@/pages/miscellaneous/maintenance.vue'),
  // },
  // {
  //   path: "/thankyou",
  //   name: "thankyou",
  //   component: () => import('@/pages/miscellaneous/thankyou.vue'),
  // },
  {
    path: "/:error(.*)",
    name: "error",
    component: () => import('@/pages/miscellaneous/error.vue'),
  },

];

const router = createRouter({
  history: createWebHistory(),
  routes,
});
export default router;
// import { useToast } from "vue-toast-notification";

// const $toast = useToast();
// let instance = $toast.success('You did it!');

// import store from './store'; // Assuming Vuex store is in ../store/index.js



// if (authStore.user != null){
//     console.log('From HEADER ? ' + authStore.user.name)
// }
// const pinia = createPinia();

// createApp(App).use(pinia);
// const authStore = useAuthStore();
// onMounted(async () => {
  // await authStore.getUser();
// })

router.beforeEach((to) => {

  const token = localStorage.getItem('user-info')
  if (to.meta.requiresAuth && !token) {
    return {
      path: '/login',
      query: { redirect: to.fullPath },
    }
  }
  if (!to.meta.requiresAuth && token) {
    return {
      path: '/',
    }
  }
})
// router.beforeEach((to, from, next) => {
//   const token = localStorage.getItem('userLogged')
//   if (token || to.name === 'login') {
//     next()
//   }  else {
//     next({ name: 'login' })
//   }
// });

// router.beforeEach((to, from, next) => {
//   if (to.matched.some((record) => record.meta.requiresAuth)) {
//     if (localStorage.getItem("userLogged") == null) {
//       next({
//         path: "/login",
//         params: { nextUrl: to.fullPath },
//       });
//     } else {
//       if (!store.state.isAuthenticated) {
//         next({
//           path: "/login",
//           params: { nextUrl: to.fullPath },
//         });
//       } else {
//         next();
//       }
//     }
//   } else {
//     next();
//   }
// });

// router.beforeEach((to, from, next) => {
//   const token = localStorage.getItem('userLogged')
//   if (token && to.name !== 'login' || to.name !== 'signup' || to.name !== 'forgot-password' || to.name !== 'password-reset') {
//     next()
//   } else if(token || to.name === 'login') {
//     next({ name: 'index' })
//   } else {
//     next({ name: 'login' })
//   }
// });

// GOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOD
// router.beforeEach((to, from, next) => {
//   const token = localStorage.getItem('userLogged')
//   if (token || to.name === 'login' || to.name === 'signup' || to.name === 'forgot-password' || to.name === 'password-reset') {
//     next()
//   } else {
//     next({ name: 'login' })
//   }
// });



